import React from 'react';
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MyChartDataTile from '../dashboard/MyChartDataTile';

const CareCompanion = ({ match }) => {
    return (
        <MyChartDataTile mode="todo" />
    );
}

export default CareCompanion;